export const MODIFY_ADD_FILE_NAME = 'MODIFY_ADD_FILE_NAME';

export function modifyAddFileName(addFileName){
    return{
        type: MODIFY_ADD_FILE_NAME,
        mainState: {
            addFileName: addFileName
        }
    }
}